<template>
  <div admin>
    <nav class="navbar navbar-dark bg-dark">
      <a class="navbar-brand" href="#">가인패드 관리자</a>
      <button type="button" class="btn btn-info" @click="logout">로그아웃</button>
    </nav>
    <div class="row p-10 no-gutters">
      <div class="col-2">
        <div class="list-group">
          <router-link to="/admin/faq" class="list-group-item">FAQ 관리</router-link>
          <router-link to="/admin/qna" class="list-group-item">QNA 관리</router-link>
          <router-link to="/admin/news" class="list-group-item">News 관리</router-link>
          <router-link to="/admin/event" class="list-group-item">Event 관리</router-link>
          <router-link to="/admin/notice" class="list-group-item">Notice 관리</router-link>
        </div>
        <hr/>
        <div class="list-group">
          <router-link to="/admin/decide" class="list-group-item">I DECIDE 응모</router-link>
          <router-link to="/admin/story" class="list-group-item">가인스토리 관리</router-link>
        </div>
        <hr/>
        <div class="list-group">
          <router-link to="/admin/labNotice" class="list-group-item">TCMLab Notice 관리</router-link>
        </div>
      </div>
      <div class="col-10 pl-10">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  @import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
  .list-group-item.router-link-active {
    z-index: 2;
    color: #fff;
    background-color: #007bff;
    border-color: #007bff
  }
</style>

<script>
export default {
  name: 'Admin',
  methods: {
    logout() {
      window.location.href = '/api/admin/logout';
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/admin/Index.vue